export type ParseOrderIdsResult =
    | { ok: true; orderIds: number[] }
    | { ok: false; errorMessageKey: string };

const hasChineseComma = (value: string) => value.includes('，');

export function parseOrderIdsFromText(value: string): ParseOrderIdsResult {
    const text = (value ?? '').trim();
    if (!text) {
        return { ok: false, errorMessageKey: 'supportTools.orderPool.errors.empty' };
    }
    if (hasChineseComma(text)) {
        return { ok: false, errorMessageKey: 'supportTools.orderPool.errors.chineseCommaNotAllowed' };
    }

    const tokens = text
        .split(/[\n,]+/g)
        .map((t) => t.trim())
        .filter(Boolean);

    if (tokens.length === 0) {
        return { ok: false, errorMessageKey: 'supportTools.orderPool.errors.empty' };
    }

    const orderIds: number[] = [];
    for (const token of tokens) {
        if (!/^\d+$/.test(token)) {
            return { ok: false, errorMessageKey: 'supportTools.orderPool.errors.invalidFormat' };
        }
        const n = Number(token);
        if (!Number.isSafeInteger(n) || n <= 0) {
            return { ok: false, errorMessageKey: 'supportTools.orderPool.errors.invalidFormat' };
        }
        orderIds.push(n);
    }

    // 去重但保持顺序
    const seen = new Set<number>();
    const deduped = orderIds.filter((id) => {
        if (seen.has(id)) return false;
        seen.add(id);
        return true;
    });

    return { ok: true, orderIds: deduped };
}

